module.exports = __webpack_public_path__ + "img/social_on.ffcb742c.png";